import Slider from './slider';
import Component from './component';
import { supportsMouseInput, supportsTouchInput } from '../utils/support';
import assets from '../assets';

const iconVolumeUp = assets.icons.volumeUp;
const iconVolumeDown = assets.icons.volumeDown;
const iconVolumeOff = assets.icons.volumeOff;
const iconVolumeMute = assets.icons.volumeMute;

export default class Volume extends Component {
  constructor (options) {
    super(options);

    this.player = this.props.player;
    this.locale = this.props.locale;

    this._slider = new Slider({
      value: this.props.volume * 100,
      className: 'iono-volume-slider'
    });

    this.onhoverin = this.onhoverin.bind(this);
    this.onhoverout = this.onhoverout.bind(this);
    this.oninput = this.oninput.bind(this);
    this.onvolumechange = this.onvolumechange.bind(this);
    this.onclick = this.onclick.bind(this);
    this.ontap = this.ontap.bind(this);
  }

  getDefaultProps () {
    return {
      volume: 1,
      muted: false,
      shown: false,
      player: null,
      locale: null
    };
  }

  show () {
    if (this.props.shown) return;

    if (this.$element.dispatchEvent(new CustomEvent('show'))) {
      this.props.shown = true;
      this.$('.iono-popover').removeAttribute('hidden');
      this.$element.dispatchEvent(new CustomEvent('shown'));
    }
  }

  hide () {
    if (!this.props.shown) return;

    if (this.$element.dispatchEvent(new CustomEvent('hide'))) {
      this.props.shown = false;
      this.$('.iono-popover').setAttribute('hidden', true);
      this.$element.dispatchEvent(new CustomEvent('hidden'));
    }
  }

  attach (element) {
    super.attach(element);
    this._slider.attach(this.$('.iono-volume-slider'));

    this.update();

    if (supportsMouseInput()) {
      this.$element.addEventListener('mouseenter', this.onhoverin);
      this.$element.addEventListener('mouseleave', this.onhoverout);
    }

    const $btnToggle = this.$('.iono-button');

    $btnToggle.addEventListener('click', this.onclick);

    if (supportsTouchInput()) {
      $btnToggle.addEventListener('touchtap', this.ontap);
    }

    this._slider.$element.addEventListener('input', this.oninput);

    if (this.player) {
      this.player.on('volumechange', this.onvolumechange);
    }
  }

  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('mouseenter', this.onhoverin);
      this.$element.removeEventListener('mouseleave', this.onhoverout);

      const $btnToggle = this.$('.iono-button');
      $btnToggle.removeEventListener('click', this.onclick);
      $btnToggle.removeEventListener('touchtap', this.ontap);
    }

    if (this.player) {
      this.player.off('volumechange', this.onvolumechange);
    }

    this._slider.detach();
    super.detach();
  }

  update () {
    this._slider.setValue(this.props.volume * 100);

    if (this.isAttached()) {
      const $muteButton = this.$('.iono-button');

      // update volume icon
      $muteButton.innerHTML = this.props.muted
        ? iconVolumeMute
        : (
            this.props.volume < 0.5
              ? (this.props.volume === 0 ? iconVolumeOff : iconVolumeDown)
              : iconVolumeUp
          );
    }
  }

  render () {
    return `
      <div class="iono-volume">
        <button class="iono-button" data-action="show-volume-menu" title="${this.locale.player.volume}">${iconVolumeUp}</button>
        <div class="iono-popover iono-volume-popover" hidden>
          ${this._slider.render()}
        </div>
      </div>
    `;
  }

  // UI Events

  onhoverin (event) {
    this.show();
  }

  onhoverout (event) {
    // prevent the slider from dissappearing while the user is interacting with it
    if (this._slider.isSliding()) {
      this._slider.$element.addEventListener('change', this.onhoverout, { once: true });
      return;
    }

    // delay hiding the slider after the user moves the cursor away, if the user
    // moves the cursor back over the volume area then cancel the hide
    const cancelHide = _ => {
      clearTimeout(timeoutId);
      this.$element.removeEventListener('mouseenter', cancelHide, { once: true });
    };

    const timeoutId = setTimeout(_ => {
      cancelHide();
      this.hide();
    }, 500);

    this.$element.addEventListener('mouseenter', cancelHide, { once: true });
  }

  ontap (event) {
    event.preventDefault();

    if (this.props.shown) {
      this.hide();
    } else {
      this.show();
    }
  }

  onclick (event) {
    this.player.setMute(!this.player.getMute());
  }

  oninput (event) {
    const volumeInputEvent = new CustomEvent('volumeinput');

    volumeInputEvent.volume = this.props.volume = this._slider.getValue() / 100;

    if (this.player) {
      this.player.setVolume(this.props.volume);
    }

    this.$element.dispatchEvent(volumeInputEvent);
  }

  // Playback events

  onvolumechange (event) {
    this.setProps({
      volume: this.player.getVolume(),
      muted: this.player.getMute()
    });
  }
}
